import { IExecution } from '@pec/aion-ui-core/interfaces/execution';
import { IProcess } from '@pec/aion-ui-core/interfaces/process';

type DeepLinkBuilder = (execution: IExecution, formPath: string) => string;

// Keyed by AutomationType. '3' = IncidentReport. Add an entry to register a new type.
const deepLinkBuilders: Partial<Record<string, DeepLinkBuilder>> = {
  '3': (execution, formPath) => {
    // Route org is the contractor's own org — the client org is passed as the clientId param instead.
    const base = `/organizations/${encodeURIComponent(execution.contractorId)}/process-automation/${encodeURIComponent(
      execution.automationId
    )}/form/${encodeURIComponent(formPath)}/execution/${encodeURIComponent(execution.id)}/edit`;

    const params = new URLSearchParams({
      contractorId: execution.contractorId,
      initiatedByContractor: 'true',
      clientId: execution.organizationId
    });

    return `${base}?${params.toString()}`;
  }
};

export const getExecutionDeepLink = (execution: IExecution, formPath: string): string | null => {
  // The API returns `type` as a number (3), so normalize before the string-keyed lookup.
  const builder = deepLinkBuilders[String(execution.type)];
  return builder ? builder(execution, formPath) : null;
};

export const resolveFormPath = (
  execution: IExecution,
  automationsForClient: IProcess[] | undefined
): string | undefined => automationsForClient?.find(automation => automation.id === execution.automationId)?.formPath;
